import Vue from 'vue'
import VueSlideoutPanel from 'vue2-slideout-panel';
import App from './App.vue'
import router from './router'
import store from './store'

import VueProgress from 'vue-progress-path'
import VueSwal from 'vue-swal'
import Ads from 'vue-google-adsense'
import Meta from 'vue-meta'

Vue.use(require('vue-script2'))
Vue.use(VueProgress);
Vue.use(VueSwal);

Vue.use(VueSlideoutPanel);
Vue.use(require('vue-moment'));
Vue.use(Ads.Adsense)
Vue.use(Meta)

export const serverBus = new Vue();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#ecomotori_map');
